import { render, staticRenderFns } from "./FooterV.vue?vue&type=template&id=6d77e1f5"
import script from "./FooterV.vue?vue&type=script&lang=js"
export * from "./FooterV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports